/**
 * Shared allowlist for in-app deep links (notifications, activity feed).
 * Must stay aligned with backend NotificationActionUrls::sanitize().
 */
export function isSafeActionUrl(url) {
  if (typeof url !== "string" || !url) return false;
  const trimmed = url.trim();
  if (!trimmed) return false;
  if (/^(https?:|javascript:|data:|vbscript:|file:)/i.test(trimmed)) return false;
  if (trimmed.startsWith("//")) return false;
  if (trimmed.includes("\0") || trimmed.includes("..") || trimmed.includes("\\")) return false;

  let path = trimmed;
  try {
    const parsed = new URL(trimmed, "https://portal.local");
    path = parsed.pathname || trimmed.split("?")[0].split("#")[0];
  } catch {
    path = trimmed.split("?")[0].split("#")[0];
  }

  if (!path.startsWith("/")) return false;

  return (
    path.startsWith("/invest/") ||
    path.startsWith("/member/") ||
    path.startsWith("/super_admin/") ||
    path === "/dashboard"
  );
}
